import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { useClosePreviewPanel } from './useClosePreviewPanel';

export const useClosePreviewPanelOnUrlChange = () => {
	const { closeOnlyPreviewPanel } = useClosePreviewPanel();
	const location = useLocation();
	const previousLocation = useRef(location);

	useEffect(() => {
		// Check if location has actually changed
		const currentLocationKey = `${location.pathname}${location.search}${location.hash}`;
		const previousLocationKey = `${previousLocation.current.pathname}${previousLocation.current.search}${previousLocation.current.hash}`;

		if (currentLocationKey !== previousLocationKey) {
			// closeOnlyPreviewPanel already includes the check for open panels
			closeOnlyPreviewPanel();

			// Update the previous location reference
			previousLocation.current = location;
		}
	}, [location, closeOnlyPreviewPanel]);
};
